



















import Vue from 'vue'

interface ComponentData {
  numberOfStars: number | null
  isStar1Disabled: boolean
  isStar2Disabled: boolean
  isStar3Disabled: boolean
  isStar4Disabled: boolean
  isStar5Disabled: boolean
}

export default Vue.extend({
  name: 'QcqQualityStarsSelector',

  components: {},

  props: {
    stars: Number,
    quality: Number
  },

  data (): ComponentData {
    return {
      numberOfStars: null,
      isStar1Disabled: true,
      isStar2Disabled: true,
      isStar3Disabled: true,
      isStar4Disabled: true,
      isStar5Disabled: true
    }
  },

  computed: {},

  watch: {
    numberOfStars (newVal: number | null): void {
      this.$emit('changeQuality', newVal)
    }
  },

  methods: {
    onResetButtonClick (): void {
      this.resetStars()
    },
    resetStars (): void {
      this.isStar1Disabled = true
      this.isStar2Disabled = true
      this.isStar3Disabled = true
      this.isStar4Disabled = true
      this.isStar5Disabled = true
      this.numberOfStars = null
    },
    star1 (): void {
      this.isStar1Disabled = false
      this.isStar2Disabled = true
      this.isStar3Disabled = true
      this.isStar4Disabled = true
      this.isStar5Disabled = true
      this.numberOfStars = 1
    },
    star2 (): void {
      this.isStar1Disabled = false
      this.isStar2Disabled = false
      this.isStar3Disabled = true
      this.isStar4Disabled = true
      this.isStar5Disabled = true
      this.numberOfStars = 2
    },
    star3 (): void {
      this.isStar1Disabled = false
      this.isStar2Disabled = false
      this.isStar3Disabled = false
      this.isStar4Disabled = true
      this.isStar5Disabled = true
      this.numberOfStars = 3
    },
    star4 (): void {
      this.isStar1Disabled = false
      this.isStar2Disabled = false
      this.isStar3Disabled = false
      this.isStar4Disabled = false
      this.isStar5Disabled = true
      this.numberOfStars = 4
    },
    star5 (): void {
      this.isStar1Disabled = false
      this.isStar2Disabled = false
      this.isStar3Disabled = false
      this.isStar4Disabled = false
      this.isStar5Disabled = false
      this.numberOfStars = 5
    }
  },

  mounted (): void {
    switch (this.quality) {
      case null:
        this.resetStars()
        break
      case 1:
        this.star1()
        break
      case 2:
        this.star2()
        break
      case 3:
        this.star3()
        break
      case 4:
        this.star4()
        break
      case 5:
        this.star5()
        break
    }
  }

})
